export default {
  'accessPolicy.globalSettings.mfaPolicy': 'MFA policy',
  'accessPolicy.globalSettings.evaluationMode': 'Evaluation mode',
  'accessPolicy.globalSettings.defaultDecision': 'Default decision',

  'accessPolicy.defaultDecision.allow': 'Allow',
  'accessPolicy.defaultDecision.deny': 'Deny',

  'accessPolicy.title': 'Access Policies',
  'accessPolicy.columns.name': 'Name',
  'accessPolicy.columns.effect': 'Effect',
  'accessPolicy.columns.priority': 'Priority',
  'accessPolicy.filters.active': 'Active',
  'accessPolicy.filters.effect': 'Effect',

  'accessPolicy.evaluationMode.denyOverrides': 'Deny overrides',
  'accessPolicy.evaluationMode.allowOverrides': 'Allow overrides',
  'accessPolicy.evaluationMode.firstMatch': 'First match',

  'accessPolicy.mfaRequirement.notRequired': 'MFA not required',
  'accessPolicy.mfaRequirement.adminsOnly': 'Admins only',
  'accessPolicy.mfaRequirement.allUsers': 'All users',

  'accessPolicy.actions.duplicate': 'Duplicate',

  'accessPolicy.definition.logicalOperator': 'Logical operator',
  'accessPolicy.definition.rules': 'Rules',
  'accessPolicy.definition.groups': 'Groups',
  'accessPolicy.definition.groupTitle': 'Group {index} (level {depth})',
  'accessPolicy.definition.ruleType': 'Rule type',
  'accessPolicy.definition.operator': 'Operator',
  'accessPolicy.definition.values': 'Values (comma-separated)',

  'accessPolicy.operator.equal': 'Equal',
  'accessPolicy.operator.notEqual': 'Not equal',
  'accessPolicy.operator.greaterThan': 'Greater than',
  'accessPolicy.operator.greaterThanOrEqual': 'Greater than or equal',
  'accessPolicy.operator.lessThan': 'Less than',
  'accessPolicy.operator.lessThanOrEqual': 'Less than or equal',
  'accessPolicy.operator.contains': 'Contains',
  'accessPolicy.operator.notContains': 'Does not contain',
  'accessPolicy.operator.isNull': 'Is null',
  'accessPolicy.operator.isNotNull': 'Is not null',

  'accessPolicy.ruleType.scopeRole': 'Scope — role',
  'accessPolicy.ruleType.scopeUserId': 'Scope — user ID',
  'accessPolicy.ruleType.scopePositionId': 'Scope — position ID',
  'accessPolicy.ruleType.scopeAreaId': 'Scope — area ID',
  'accessPolicy.ruleType.scopeUserGroupId': 'Scope — user group ID',
  'accessPolicy.ruleType.scopeAppClientId': 'Scope — app client ID',
  'accessPolicy.ruleType.scopeAppId': 'Scope — app ID',
  'accessPolicy.ruleType.scopePortalId': 'Scope — portal ID',
  'accessPolicy.ruleType.ipSingle': 'IP — single address',
  'accessPolicy.ruleType.ipRange': 'IP — range',
  'accessPolicy.ruleType.ipCidr': 'IP — CIDR',
  'accessPolicy.ruleType.geoCountryCode': 'Geo — country code',
  'accessPolicy.ruleType.geoState': 'Geo — state / region',
  'accessPolicy.ruleType.geoCity': 'Geo — city',
  'accessPolicy.ruleType.userAgent': 'User agent',
  'accessPolicy.ruleType.deviceKnown': 'Known device',
};
